<template>
    <div class="component-container" style="overflow-x: hidden;overflow-y: hidden;">
        <div class="page-resa row" style="align-items: flex-start; padding: 0px">
            <div v-if="prestation" class="col-lg-6 col-md-12 mx-auto">
                <div v-if="parseInt(this.prestation.type) != -1">
                    <p class="sub-title-resa mb-3">Pour qui ?</p>
                    <div
                        v-for="(userNb, i) in parseInt(this.prestation.type)"
                        :key="i"
                        class="g-column x-between"
                        style="width: 100%"
                    >
                        <!-- {{ customers[i] = customers[i] ? customers[i] : ['first_name' = "", 'last_name' = ""] }} -->

                        <div v-if="type == 'prestation'" class="g-column">
                            <label class="label mb-2" style="color:#8B8B8B">Prénom:</label>
                            <input
                                v-if="i==0"
                                type="text"
                                placeholder="Prénom"
                                v-model="customers[i].first_name"
                                required
                            />
                            <input
                                v-if="i!=0"
                                type="text"
                                placeholder="Prénom"
                                v-model="customers[i].first_name"

                                required
                            />
                            <label class="label mb-2" style="color:#8B8B8B">Nom: </label>
                            <input
                                v-if="i==0"
                                type="text"
                                placeholder="Nom"
                                v-model="customers[i].last_name"
                                required
                            />
                            <input
                                v-if="i!=0"
                                type="text"
                                placeholder="Nom"
                                v-model="customers[i].last_name"
                                required
                            />
                        </div>
                        <div v-if="type != 'prestation'" class="g-column">
                            <label class="label mb-2" style="color:#8B8B8B">Prénom: </label>
                            <input
                                v-if="i==0"
                                type="text"
                                placeholder="Prénom"
                                v-model="customers[i].first_name"
                                name="first_name"
                                required
                            />

                            <input
                                v-if="i!=0"
                                type="text"
                                placeholder="Prénom"
                                v-model="customers[i].first_name"
                                name="first_name"
                                required
                            />
                            <label class="label mb-2" style="color:#8B8B8B">Nom: </label>
                            <input
                                v-if="i==0"
                                type="text"
                                placeholder="Nom"
                                v-model="customers[i].last_name"
                                name="last_name"
                                required
                            />
                            <input
                                v-if="i!=0"
                                type="text"
                                placeholder="Nom"
                                v-model="customers[i].last_name"
                                name="last_name"
                                required
                            />
                        </div>
                    </div>
                </div>
                <div v-if="parseInt(this.prestation.type) == -1">
                    <p class="sub-title-resa  mb-3">Pour qui ?</p>
                    <div
                        v-for="(nb_user, i) in parseInt(this.nb_user)"
                        :key="i"
                        class="g-column x-between"
                        style="width: 100%"
                    >
                        <label class="label mb-2" style="color:#8B8B8B">Prénom</label>
                        <input
                            type="text"
                            placeholder="Prénom"
                            v-model="customers[i].first_name"
                            name="first_name"
                            required
                        />
                        <label class="label mb-2" style="color:#8B8B8B">Nom</label>
                        <input
                            type="text"
                            placeholder="Nom"
                            v-model="customers[i].last_name"
                            name="last_name"
                            required
                        />
                    </div>
                </div>
            </div>

            <div class="col-md-6 mx-auto">

                <p class="sub-title-resa" :style="prestations.length > 0?'':{'marin-bottom':'20px'}">Quelle prestation
                    souhaitez-vous réserver ?</p>
                <div v-if="prestations.length > 0">
                    <!-- {{ prestation }} -->
                    <div v-if="selectedPrestations.length > 0"
                         style="width: max-content;margin:20px auto;text-align: center;">
                        <div v-for="(sel, s) in selectedPrestations" :key="s" style="color: gray; font-size: 16px;">
                            <div v-for="(prestation, i) in JSON.parse(JSON.stringify(prestations))" :key="i">
                                <div v-if="sel == prestation.rowId">
                                    {{ numberToWord[s] ? numberToWord[s] + ' prestation' : s + 1 }} : {{
                                        prestation.name
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-for="(localPrestation, i) in JSON.parse(JSON.stringify(this.prestations))" :key="i">
                        <div v-if="!booked.includes(localPrestation.rowId)">
                            <div class="tooltip">
                                <input hidden disabled="true"
                                       v-if="type !== 'package' && type !== 'serie' && type !== 'treatment'"
                                       type="checkbox"
                                       :id="localPrestation.id"
                                       :value="localPrestation.rowId"
                                       :checked="true"
                                       @click="addSelectedPrestations($event)"
                                />

                                <label :for="localPrestation.id">
                                    <span class="circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16.745" height="11.64"
                                             viewBox="0 0 18.745 13.64"
                                             style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);">
                                            <g id="check-svgrepo-com_1_" data-name="check-svgrepo-com (1)"
                                               transform="translate(0 -55.188)">
                                                <path id="Tracé_125" data-name="Tracé 125"
                                                      d="M18.2,58.39,8.307,68.279a1.876,1.876,0,0,1-2.653,0l-5.1-5.105A1.876,1.876,0,0,1,3.2,60.52L6.981,64.3l8.562-8.562A1.876,1.876,0,0,1,18.2,58.39Z"
                                                      transform="translate(0 0)" fill="#fff"></path>
                                            </g>
                                        </svg>
                                    </span> {{ localPrestation.name }}:
                                    {{ localPrestation.commercial_time }} min - {{ localPrestation.item.price }} €
                                    <i
                                        v-if="
                                        type != 'package' &&
                                            type != 'serie' &&
                                            (localPrestation.always_first == 1 || localPrestation.always_last == 1)
                                    "
                                        class="fa fa-thin fa-exclamation"
                                        style="color: red;margin-left: 7px"
                                    ></i>
                                </label>
                                <p
                                    v-if="type != 'package' && type != 'serie' && localPrestation.always_first == 1"
                                    style="color: gray; font-size: 16px;"
                                    class="tooltiptext"
                                >
                                    Veuillez choisir de préférence cette prestation avant les autres
                                </p>
                                <p
                                    v-if="type != 'package' && type != 'serie' && localPrestation.always_last == 1"
                                    style="color: gray; font-size: 16px;"
                                    class="tooltiptext"
                                >
                                    Veuillez choisir de préférence cette prestation après les autres
                                </p>

                                <p v-if="voucher1 ?? voucher2 ?? voucher3">Bon cadeau appliqué au total : {{
                                        voucher1
                                    }}{{ voucher2 }}{{ voucher3 }} €</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="type === 'serie'">{{ prestation.name }} (Abonnement)</div>

                <div v-else-if="type === 'treatment'">{{ prestation.name }} (Cure)</div>

                <div v-else style="display: flex; align-items: center; height: 100%; width: 100%">
                    <!-- <p class="loading">Chargement des créneaux</p> -->
                    <span class="lds-span" :style="ldsSpan">Chargement</span>
                    <div class="lds-ring">
                        <div :style="ldsRing"></div>
                        <div :style="ldsRing"></div>
                        <div :style="ldsRing"></div>
                        <div :style="ldsRing"></div>
                    </div>
                </div>
                <div class="description-resa">
                    <li>Si vous cochez une seule prestation, vous réserverez pour cette prestation et pour une
                        personne.
                    </li>
                    <li>Si vous cochez plusieurs prestations, elles seront réservées à la suite les unes des autres.
                    </li>
                    <li>Pour réserver des prestations pour plusieurs personnes, vous devez faire une réservation à la
                        fois
                    </li>
                </div>

                <div class="resa-row text-center" v-if="prestationSelected">
                    <input type="hidden" id="prestation" name="prestation" :value="JSON.stringify(this.prestation)"/>
                    <input type="hidden" id="select" name="select" :value="JSON.stringify(this.selectedSlot)"/>
                    <input type="hidden" id="practi" name="practi" :value="JSON.stringify(this.selectPracti)"/>
                    <input type="hidden" id="space" name="space" :value="JSON.stringify(this.selectSpace)"/>
                    <input type="hidden" id="type" name="type" :value="this.prestation.type"/>
                    <input type="hidden" id="nbUser" name="nbUser" :value="this.nb_user"/>
                    <input type="hidden" id="type" name="type" :value="this.type"/>
                    <input type="hidden" id="ok" name="ok" :value="1"/>
                    <input type="hidden" id="all" name="all" :value="JSON.stringify(this.allPrestations)"/>
                    <input type="hidden" id="selectedPrestations" name="selectedPrestations"
                           :value="JSON.stringify(this.selectedPrestations)"/>
                    <input type="hidden" name="test" id="test" value="tet"/>
                    <input type="hidden" name="esta" id="esta" :value="JSON.stringify(this.establishments)"/>


                    <input
                        v-if="this.type == 'serie'"
                        type="hidden"
                        id="serie_user_id"
                        name="serie_user_id"
                        :value="this.serie_user_id"
                    />
                    <input
                        v-if="this.type === 'treatment'"
                        type="hidden"
                        id="treatment_user_id"
                        name="treatment_user_id"
                        :value="this.treatment_user_id"
                    />
                    <input
                        v-if="this.type == 'package'"
                        type="hidden"
                        id="prestations"
                        name="prestations"
                        :value="JSON.stringify(this.prestations)"
                    />
                    <input
                        v-if="this.type == 'package'"
                        type="hidden"
                        id="package_user_id"
                        name="package_user_id"
                        :value="this.package_user_id"
                    />
                    <button type="submit" class="time-slots">Suivant</button>
                </div>
            </div>

        </div>
    </div>

</template>


<script>
import {addDays, dayToFrFormat} from '../utils/date'

export default {
    name: 'TimeSlot',
    props: ['prestation', 'establishments', 'type', 'user', 'treatment_user_id', 'serie_user_id', 'package_user_id', 'voucher1', 'voucher2', 'voucher3', 'primaryColor'],
    computed: {
        currentEstablishment() {
            return this.establishments.filter(x => x.id === this.prestation.establishment_id)
        },
        getFirstNameIfExist() {
            if (this.user) {
                return this.user.first_name
            }
        },
        getLastNameIfExist() {
            if (this.user) {
                return this.user.last_name
            }
        },
        ldsSpan() {
            return {
                "font-family": 'Serif',
                "color": this.primaryColor,
            }
        },
        ldsRing() {
            return {
                "border": "3px solid " + this.primaryColor,
                "border-color": this.primaryColor + " transparent transparent transparent",
            }
        }
    },
    data: () => ({
        first_name: null,
        customers: [],
        last_name: null,
        availableSlots: [],
        unavailableSlots: [],
        arrayEvents: null,
        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        menu: false,
        currentDate: null,
        dateNext: null,
        dateNextTwo: null,
        currentDateFormat: null,
        dateNextFormat: null,
        dateNextTwoFormat: null,
        nowDate: new Date().toISOString().slice(0, 10),
        segments: [],
        staffs: null,
        spaces: null,
        selectedSlot: {},
        openingHours: 9,
        closingHours: 18,
        establishment: {},
        spaces_list: null,
        staffs_list: null,
        nb_user: 1,
        time_slots: null,
        selectPracti: null,
        selectSpace: null,
        selectID: null,
        selectDate: null,
        isLoading: false,
        isLoadingOther: false,
        otherPrestations: {},
        otherSelect: 0,
        allPrestations: [],
        prestations: [],
        // prestationsBasket: null,
        selectedPrestations: [],
        booked: [],
        prestationSelected: true,
        showCalendar: false,
        showDisponibilities: false,
        selectedTimeSlot: null,
        numberToWord: [
            'Première',
            'Deuxième',
            'Troisième',
            'Quatrième',
            'Cinquième',
            'Sixième',
            'Septième',
            'Huitième',
            'Neuvième',
        ],
        practiDispo: null,
        practiShow: false,
        currentPracti: null,
        nbreStaff: 0,
        selectedStaff: null
    }),
    mounted() {
        (this.currentDateFormat = dayToFrFormat(addDays(this.date, 0))),
            (this.dateNextFormat = dayToFrFormat(addDays(this.date, 1))),
            (this.dateNextTwoFormat = dayToFrFormat(addDays(this.date, 2))),
            (this.arrayEvents = [...Array(6)].map(() => {
                const day = Math.floor(Math.random() * 30)
                const d = new Date()
                d.setDate(day)
                return d.toISOString().substr(0, 10)
            }))
        this.currentDate = addDays(this.date, 0)
        this.dateNext = addDays(this.date, 1)
        this.dateNextTwo = addDays(this.date, 2)
        this.checking()
        this.getAvaillableBook()
        this.getEstablishments()
        moment.locale('fr')
        this.nb_user = 1
        if (this.prestation.type >= 2) {
            this.nb_user = this.prestation.type
        }
        this.establishment = this.establishments[0]
        this.getSpacesEsta(this.establishment.id)
        this.getStaffsEsta(this.establishment.id)
        this.first_name = this.user.first_name
        this.last_name = this.user.last_name
        if (!['serie', 'treatment'].includes(this.type)) {
            this.getCartPrestation()
        } else {
            this.prestationSelected = true
        }
        for (let index = 0; index < this.nb_user; index++) {
            if (index == 0) {
                // this.customers[index] = {'first_name': this.first_name, 'last_name': this.last_name}

            } else {
                //this.customers[index] = {'first_name': "", 'last_name': ""}

            }
            this.customers.push({'first_name': this.first_name, 'last_name': this.last_name})

        }


    },
    methods: {
        setPracti(e) {
            if (this.currentPracti == e)
                this.currentPracti = null
            else
                this.currentPracti = e;

        },
        addFirst() {
            this.prestations.map(e => {
                if (e.always_first == 1) {
                    this.selectedPrestations.push(e.rowId)
                }
            })
        },
        addLast(a) {
            var x = this.prestations.length - 1
            this.prestations.map(e => {
                if (e.always_last == 1) {
                    if (this.selectedPrestations.indexOf(e.rowId) != -1)
                        this.selectedPrestations.splice(this.selectedPrestations.indexOf(e.rowId), 1)
                }
            })
            if (this.selectedPrestations.indexOf(null) != -1)
                this.selectedPrestations.splice(this.selectedPrestations.indexOf(null), 1)
            if (a != null) this.selectedPrestations.push(a)
            this.prestations.map(e => {
                if (e.always_last == 1) {
                    this.selectedPrestations.push(e.rowId)
                }
            })
        },
        async deleteItem() {
            await axios.post(`/reservation/delete/tmp`, {all: this.allPrestations})
            this.allPrestations = []
            this.selectedPrestations = []
            this.booked = []
            this.selectDate = []
        },
        addSelectedPrestations(event) {
            this.prestationSelected = true
            if (this.selectedPrestations.includes(event.target.value)) {
                this.selectedPrestations.indexOf(event.target.value)
                this.selectedPrestations.splice(this.selectedPrestations.indexOf(event.target.value), 1)
            } else {
                this.selectedPrestations.push(event.target.value)
            }
        },
        affectStaff(event, prestationByStaff) {

            prestationByStaff.staffs.map(e => {
                e.checked = false
                if (event.target.value == e.staff.id) {
                    e.checked = true
                }

                console.log(e);
            })


        },
        async loadTimeslot() {
            this.isLoading = true
            if (this.type !== 'package' && this.type !== 'serie' && this.type !== 'treatment') {
                console.log("establishment",this.establishment)
                console.log("staffs",this.staffs)
                console.log("spaces_list",this.spaces_list)
                console.log("nb_user",this.nb_user)
                console.log("prestations",this.prestations)
                console.log("nb_user",this.nb_user)
                console.log("type",this.prestation.type)
                console.log("establishment_id",this.establishment.id)
                console.log("date",this.date)
                console.log("selectedPrestations",this.sprs)
                let response = await axios
                    .post(`/reservation/getTimeSlot/2`, {
                        establishment: this.establishment,
                        staffs: this.staffs_list,
                        spaces: this.spaces_list,
                        nb_user: this.nb_user,
                        prestations: this.prestations,
                        numberUser: this.nb_user,
                        type: this.prestation.type,
                        id_esta: this.establishment.id,
                        date: moment(this.date).format('x'),
                        selectedPrestations: this.selectedPrestations,
                    })
                    .then(response => {
                        this.isLoading = false
                        this.time_slots = response.data
                    })
            } else {
                let response = await axios
                    .post(`/forfait/getTimeSlot`, {
                        establishment: this.establishment,
                        staffs: this.staffs_list,
                        spaces: this.spaces_list,
                        nb_user: this.nb_user,
                        prestations: [this.prestation],
                        numberUser: this.nb_user,
                        type: this.prestation.type,
                        id_esta: this.establishment.id,
                        date: moment(this.date).format('x'),
                    })
                    .then(response => {
                        this.isLoading = false
                        this.time_slots = response.data
                    })
            }
        },
        timestampToDate(date) {
            return moment.unix(date)
        },
        async getCartPrestation() {
            axios.get('/getCartPrestations').then(res => {
                this.prestations = []
                this.prestations = res.data
                this.nbreStaff = res.data[0]['item'].staff_nbr
                this.addFirst()
                this.addLast(null)
                this.prestations.forEach((element, index) => {
                    this.selectedPrestations.push(element.rowId);

                });
            })

        },
        selectOtherPresta(id, duration, date, name, price, esta, staffs, space) {
            this.otherSelect = id
            var start = this.allPrestations[this.allPrestations.length - 1].end_time
            this.selectedSlot = {
                id: id,
                name: name,
                price: price,
                establishment_id: esta,
                start_time: start,
                end_time: start + duration * 60,
                day: date,
                practi: staffs,
                space: space,
                item: 1,
            }
            this.allPrestations.push(this.selectedSlot)
            this.getOtherPresta(start + duration * 60, this.prestation.type)
        },

        async getAvaillableBook() {
            axios.get(`/getAvailable/${this.date}`).then(response => {
                this.availableSlots = response.data
            })
        },
        async changeDate(event) {
            this.getAvaillableBook()
            this.currentDateFormat = dayToFrFormat(addDays(event, 0))
            this.dateNextFormat = dayToFrFormat(addDays(event, 1))
            this.dateNextTwoFormat = dayToFrFormat(addDays(event, 2))

            this.checking()
            this.getSpacesEsta(this.establishment.id)
            this.getStaffsEsta(this.establishment.id)
            this.loadTimeslot()
            this.showDisponibilities = true
            this.practiShow = false;

        },

        async displayAllPracti(ts) {
            this.practiShow = false;
            this.practiDispo = ts[0]['practi'];
            this.selectedTimeSlot = ts
            /*
            if (this.practiDispo.length <= 0) {
                this.selectMultipleSlot(this.selectedTimeSlot, this.selectedTimeSlot[0]['date'], this.currentDate, null)
            } else {
                this.practiShow = true;
            }
            */

            this.practiShow = true;

            // console.log(this.practiShow)
        },

        async selectMultipleSlot(item, date, day, practi) {
            // item[0]["practi"] = practi
            // item['preference_practi'] = practi
            this.selectedSlot = {
                prestation: item,
                start_first_time: parseInt(moment(date).format('X')),
                end_first_time: parseInt(moment(date).format('X')) + parseInt(this.prestation.duration * 60),
                day: day,
                pref_prati: practi,
            }
            this.selectDate = item
            console.log(item)
            item.forEach(element => this.booked.push(element.rowId))
            this.selectedPrestations = []
            this.time_slots = []
            await axios.post(`/soin/reservation/confirmation`, {
                all: JSON.stringify(this.selectedSlot),
                nbUser: this.nb_user,
                customers: this.customers,
                preference_practi: practi
            })
            // this.booked = item.rowId
            this.allPrestations.push(this.selectedSlot)
            this.practiShow = false

        },

        async selectMultipleSlotPackage(item, date, day) {
            this.selectedSlot = {
                prestation: item,
                start_first_time: parseInt(moment(date).format('X')),
                end_first_time: parseInt(moment(date).format('X')) + parseInt(this.prestation.duration),
                day: day,
            }
            this.selectDate = item
        },

        async selectSlot(event, item, date, practi, space) {
            //
            this.selectedSlot = {
                id: this.prestation.id,
                name: this.prestation.name,
                price: this.prestation.price,
                start_time: parseInt(moment(item).format('X')),
                end_time: parseInt(moment(item).format('X')) + parseInt(this.prestation.duration * 60),
                day: date,
                practi: practi,
                space: space,
                item,
            }
            this.allPrestations = [this.selectedSlot]
            this.selectPracti = practi
            this.selectSpace = space
            this.selectDate = item

            document.querySelectorAll('.time-slots').forEach(el => {
                el.classList.remove('active')
            })

            this.getOtherPresta(
                parseInt(moment(item).format('X')) + parseInt(this.prestation.duration * 60),
                this.prestation.type
            )
        },

        async getOtherPresta(date, nb_user) {
            this.isLoadingOther = true
            if (nb_user == -1) {
                nb_user = this.nb_user
            }
            let response = await axios
                .post(`/soin/reservation/get/available`, {
                    establishment_id: 1,
                    start: date,
                    nb_user: nb_user,
                })
                .then(response => {
                    this.otherPrestations = response.data
                    this.isLoadingOther = false
                })
            // this.otherPrestations = JSON.parse(JSON.stringify(response.data));
            return response
        },

        selectEsta(event) {
            this.establishment = JSON.parse(event.target.value)
            this.getSpacesEsta(this.establishment.id)
            this.getStaffsEsta(this.establishment.id)
        },


        displayDate(date) {
            if (
                moment(date)
                    .calendar()
                    .includes('/')
            )
                return moment(date).format('dddd Do MMMM YYYY à HH:mm')
            return moment(date).calendar()
        },

        async getSpacesEsta(esta) {
            let response = await axios
                .post(`/soin/getSpaces/${this.establishment.id}`, {
                    prestation_id: this.prestation.id,
                })
                .then(response => {
                    this.spaces_list = response.data
                })
            return response
        },

        async getStaffsEsta(esta) {
            let response = await axios
                .post(`/soin/getStaffs/${this.establishment.id}`, {
                    prestation: this.prestation,
                })
                .then(response => {
                    this.practiDispo = response.data
                    // this.currentPracti = response.data[0].id
                })
            return response
        },

        async getMaterialEstaPresta() {
            let response = await axios
                .post(`/soin/getMaterialEstaPresta/${this.establishment.id}`, {
                    prestation: this.prestation,
                })
                .then(response => {
                })
            return response
        },

        async getTimeSlot(esta) {
            this.isLoading = true
            if (this.type === 'package' || this.type === 'serie' || this.type === 'treatment') {
                let response = await axios
                    .post(`/forfait/getTimeSlot`, {
                        establishment: this.establishment,
                        staffs: this.staffs_list,
                        spaces: this.spaces_list,
                        nb_user: this.nb_user,
                        prestations: this.prestations,
                        numberUser: this.nb_user,
                        type: this.prestation.type,
                        id_esta: this.establishment.id,
                        date: moment(this.date).format('x'),
                    })
                    .then(response => {
                        this.isLoading = false
                        this.time_slots = response.data
                    })
            } else {
                let response = await axios
                    .post(`/soin/getTimeSlot`, {
                        establishment: this.establishment,
                        staffs: this.staffs_list,
                        spaces: this.spaces_list,
                        nb_user: this.nb_user,
                        prestation: this.prestation,
                        numberUser: this.nb_user,
                        type: this.prestation.type,
                        date: moment(this.date).format('x'),
                    })
                    .then(response => {
                        this.isLoading = false
                        this.time_slots = response.data
                    })
            }
            return response
        },

        getFormatTime(date) {
            return moment(date).format('HH:mm')
        },

        async validate() {
            this.checking()
            await axios.post('/soin/reservation/create', {
                day: this.selectedSlot.day,
                start_time: this.selectedSlot.start_time,
                end_time: this.selectedSlot.end_time,
                prestation_id: this.prestation.id,
                available_staff: this.staffs[0].id,
                available_space: this.spaces[0].id,
            })
        },

        async checkStaffs() {
            await axios
                .post('/soin/staffs', {
                    staffs: this.prestation.staffs,
                })
                .then(response => {
                    this.staffs = response.data
                })
        },

        async checkSpaces() {
            await axios
                .post('/soin/spaces', {
                    spaces: this.prestation.spaces,
                })
                .then(response => {
                    this.spaces = response.data
                })
        },

        async checkSlots() {
            await axios
                .post('/soin/slots', {
                    day: new Date(this.date),
                    prestation_id: this.prestation.id,
                })
                .then(response => {
                    response.data.forEach(el => {
                        let slot = {
                            start_time: el.start_time,
                            end_time: el.end_time,
                            day: el.day,
                        }
                        this.unavailableSlots.push(slot)
                    })
                })
        },

        async getEstablishments() {
            await axios.post('/etablissements').then(response => {
                this.establishmentsOptions = response
            })
        },

        checking() {
            // this.checkStaffs()
            // this.checkSpaces()
            // this.checkSlots()
            //   this.generateSlots()
        },
    },
}
</script>

<style scoped>
.tooltip {
    opacity: 1 !important;
    position: relative;
    display: inline-block; /* If you want dots under the hoverable text */
    z-index: 1;
}

input[type='checkbox'] + label {
    display: flex;
    justify-content: space-around;
    background: #fff;
    padding: 0.75rem 1.5rem;
    margin-bottom: 1rem;
    border-radius: 31px;
    border: 1px solid #E6E6E6;
    color: #000;
    align-items: center;
}

input[type='checkbox'] + label span.circle svg {
    display: none;
}

input[type='checkbox']:checked + label span.circle svg {
    display: block;
}

input[type='checkbox']:checked + label span.circle {
    position: relative;
    width: 26px;
    min-width: 26px;
    max-width: 26px;
    height: 26px;
    display: inline-block;
    background-color: hsl(var(--p));
    border-radius: 50%;
    margin-right: 0.75rem;
}

input[type='checkbox'] + label span.circle {
    width: 26px;
    min-width: 26px;
    max-width: 26px;
    height: 26px;
    display: inline-block;
    border: 1px solid #E6E6E6;
    border-radius: 50%;
    margin-right: 0.75rem;
}

/* Tooltip text */
.tooltip .tooltiptext {
    visibility: hidden;
    background-color: #f1f1f1;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;
    top: -5px;
    left: 105%;
    width: 100%;
    /* -webkit-box-shadow: 7px 6px 19px 0px #000000;
box-shadow: 7px 6px 19px 0px #000000; */

    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 1;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
    visibility: visible;
}

div:deep(.v-application--wrap ) {
    min-height: initial;
}

.component-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.page-resa {
    padding-bottom: 10rem;
    width: 100%;
    gap: 20px;
    display: flex;
}

.sub-title-resa {
    font-size: 1.5rem;
    font-weight: 700;
}

.description-resa {
    margin-top: 2rem;
    margin-bottom: 2rem;
}

.description-resa li {
    color: gray;
    font-size: 12px;
    list-style-position: inside;
}

.resa-col-1 {
    flex: 3;
}

.resa-col-2-3 {
    display: flex;
    flex: 2;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

@media (min-width: 2000px) {
    .resa-col-2-3 {
        flex-direction: row;
    }
}

.resa-col-2,
.resa-col-3 {
    max-width: 350px;
}

@media (max-width: 1279px) {
    .page-resa {
        flex-direction: column;
    }

    .resa-col-1,
    .resa-col-2,
    .resa-col-3 {
        width: 100%;
    }

    .resa-col-2,
    .resa-col-3 {
        max-width: fit-content;
        min-width: 100%;
    }
}

.title-resa {
    font-family: 'Playfair Display';
    color: black;
}

.calendar-container {
    width: 35%;
}

.titleSlot {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 1rem;
}

.slot-container {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
}

.slot-time {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 1rem;
}

.card-slot {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid black;
    width: 12rem;
    padding: 1rem 0;
    margin: 1rem 0;
    transition: all 0.2s ease-in-out;
}

.card-slot:hover {
    background-color: black;
    color: #cca000;
}

.card-slot.active {
    background-color: black;
    color: #cca000;
}

.line-separator {
    border-left: 1px solid rgba(128, 128, 128, 0.772);
    height: auto;
    width: 1rem;
}

/*  */

.lds-ring {
    display: inline-block;
    position: relative;
    width: 40px;
    height: 40px;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    margin: 4px;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
